import { isPhoneInLandscape } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'
import { isHeightConstrained } from '../../styles'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      wrap: {
        boxShadow: tokens.elevationLow,
        maxWidth: 'calc(100% - 48px)',
        minHeight: 0,

        [isPhoneInLandscape]: {
          maxWidth: 'calc(100% - 6px * 2)',
        },

        [isHeightConstrained]: {
          height: '100%',
          marginTop: '2px',
          maxHeight: 'calc(100vh - 4px)',
          minHeight: 'inherit',
          overflowY: 'auto',
        },
      },

      close: {
        insetInlineEnd: 0,
        top: 0,
      },

      modalBase: {
        minHeight: '100%',
      },
    },
  } as const
}
